import React from 'react';
import Link from 'gatsby-link';
import Radium from 'radium';
import {StyleRoot} from 'radium'
import Color from 'color';

import Appshelf from '../components/appshelf';

class Apps extends React.Component {

    render() {
        return (
            <div id="pin-container">
                <StyleRoot>
                    <Appshelf data={this.props.data} pathname={this.props.location.pathname} /></StyleRoot>
            </div>
        )
    }
}

export default Apps



// WEBPACK FOOTER //
// ./src/pages/apps.en.jsx